var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex align-center justify-center flex-column",staticStyle:{"height":"100%"}},[_c('img',{staticClass:"mb-6 shrink px-4",staticStyle:{"max-height":"100px","max-width":"400px"},attrs:{"src":_vm.logoURL}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }